export enum ShipmentPlannerProfileEndpoint {
  Base = '/shipments',
  Profiles = '/profiles',
  Clone = '/clone',
  Profile = '/profile',
  Default = '/default',
  Usage = '/usage',
  Report = '/report',
  Fields = '/fields',
}
